import { GeneralPropertiesController } from './general-properties.controller'

function generalProperties () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      data: '<',
      formProperties: '=',
      tabsLoadingData: '=',
      errors: '<',
      features: '<',
      addons: '<',
      openUpgradeCompanyPlanDialog: '&'
    },
    templateUrl: '/arts/directives/general-properties/general-properties-directive.html?$$REVISION$$',
    controller: GeneralPropertiesController
  }
}

export { generalProperties }
